(() => {
  if (!/^\/products\/hush-gummies(?:\/|$)/.test(location.pathname) || window.HermeticaHushGrowthAnalytics20260722) return;
  window.HermeticaHushGrowthAnalytics20260722 = true;

  const experimentId = 'hush_growth_rebuild_20260722';
  const experimentVariant = 'staging_rebuild_v1';
  const sessionKey = 'hsf_hush_growth_session';
  const seen = new Set();
  const randomId = () => {
    try {
      return window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    } catch (_) {
      return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }
  };
  const sessionId = (() => {
    try {
      let value = sessionStorage.getItem(sessionKey);
      if (!value) {
        value = randomId();
        sessionStorage.setItem(sessionKey, value);
      }
      return value;
    } catch (_) {
      return 'session-unavailable';
    }
  })();

  const uuid = randomId;
  const currentState = () => {
    const variant = document.querySelector('.mrk-bundle-wrap--hush .mrk-bundle__card-radio:checked[data-variant-id]');
    const purchase = document.querySelector('.mrk-bundle-wrap--hush .mrk-bundle__sub-radio:checked');
    const quantity = Number((variant?.value || variant?.getAttribute('aria-label') || '1').match(/\d+/)?.[0] || 1);
    return {
      product_id: document.querySelector('[data-hush-growth-rebuild]')?.dataset.productId || '',
      variant_id: variant?.dataset.variantId || '',
      bundle_quantity: quantity,
      purchase_type: purchase?.dataset.isSubscription === 'true' ? 'subscription' : 'one_time',
      selling_plan_id: purchase?.dataset.sellingPlanId || '',
      price: Number(variant?.dataset.price || 0) / 100,
      currency: 'USD',
    };
  };

  const emit = (name, params = {}, dedupeKey = '') => {
    const key = dedupeKey ? `${name}:${dedupeKey}` : '';
    if (key && seen.has(key)) return;
    if (key) seen.add(key);
    const payload = {
      ...currentState(),
      ...params,
      event_id: uuid(),
      session_id: sessionId,
      experiment_id: experimentId,
      experiment_variant: experimentVariant,
      page_type: 'product',
      product_handle: 'hush-gummies',
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: `hsf_${name}`, ...payload });
    if (typeof window.gtag === 'function') window.gtag('event', `hsf_${name}`, payload);
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('.mrk-bundle-wrap--hush .mrk-bundle__card-radio')) {
      emit('bundle_select', { placement: 'primary_purchase', selected_label: event.target.value || '' });
    }
    if (event.target.matches('.mrk-bundle-wrap--hush .mrk-bundle__sub-radio')) {
      emit('purchase_option_select', { placement: 'primary_purchase' });
    }
  }, true);

  document.addEventListener('click', (event) => {
    const galleryControl = event.target.closest('media-gallery button, product-media button, .product-media-gallery button, .thumbnail, [data-hsf-curated-gallery-zoom], [data-hsf-curated-gallery-thumbnail]');
    if (galleryControl) emit('gallery_interaction', { placement: 'primary_gallery', control: galleryControl.getAttribute('aria-label') || 'gallery_control' });

    const ingredient = event.target.closest('[data-hush-ingredient]');
    if (ingredient) emit('ingredient_interaction', { ingredient: ingredient.dataset.hushIngredient, placement: 'formula_grid' }, ingredient.dataset.hushIngredient);

    const review = event.target.closest('[data-hush-review-link], a[href="#hsf-reviews"]');
    if (review) emit('review_interaction', { placement: review.closest('[data-hush-section]')?.dataset.hushSection || 'primary_purchase' });

    const faq = event.target.closest('[data-hush-faq] summary');
    if (faq) emit('faq_interaction', { question: faq.textContent.trim(), placement: 'faq' });

    const research = event.target.closest('[data-hsf-research-link]');
    if (research) {
      try {
        const destination = new URL(research.href, window.location.origin);
        emit('research_link_click', {
          placement: 'research_bridge',
          research_surface: research.dataset.hsfResearchSurface || '',
          link_text: research.querySelector('strong')?.textContent?.trim() || research.textContent.trim(),
          link_domain: destination.hostname,
          link_path: destination.pathname,
        });
      } catch (_) {
        emit('research_link_click', {
          placement: 'research_bridge',
          research_surface: research.dataset.hsfResearchSurface || '',
        });
      }
    }

    const bundle = event.target.closest('[data-hush-bundle-select]');
    if (bundle) {
      event.preventDefault();
      const requestedVariant = bundle.dataset.variantId;
      const target = document.querySelector(`.mrk-bundle-wrap--hush .mrk-bundle__card-radio[data-variant-id="${CSS.escape(requestedVariant)}"]`);
      if (target && !target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
      emit('bundle_select', { placement: 'comparison_cards', requested_bundle_quantity: Number(bundle.dataset.hushBundleSelect || 1) });
      window.setTimeout(() => document.getElementById('hush-buy')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 120);
    }

    const cta = event.target.closest('[data-hush-cta]');
    if (cta) emit('cta_click', { placement: cta.dataset.hushCta });
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    let placement = 'primary_purchase';
    if (form.closest('.hsf-mobile-buybar')) placement = 'mobile_sticky';
    else if (form.closest('sticky-add-to-cart')) placement = 'desktop_sticky';
    emit('add_to_cart_intent', { placement });
  }, true);

  const observe = () => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.35) return;
        const section = entry.target.dataset.hushSection;
        emit('section_view', { section, placement: section }, section);
        observer.unobserve(entry.target);
      });
    }, { threshold: [0.35] });
    document.querySelectorAll('[data-hush-section]').forEach((node) => observer.observe(node));

    const sticky = document.querySelector('.hsf-mobile-buybar');
    if (sticky) {
      const stickyObserver = new MutationObserver(() => {
        if (sticky.classList.contains('is-visible')) emit('sticky_atc_impression', { placement: 'mobile_sticky' }, 'mobile');
      });
      stickyObserver.observe(sticky, { attributes: true, attributeFilter: ['class'] });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true });
  else observe();
})();
